import * as Yup from 'yup';
import moment from 'moment';
import { translate } from 'helpers/intl';
import messages from 'containers/SignupPages/PersonalInfo/messages';
import { isFieldRequired } from 'utils/string';

const isConditionalFieldRequired = (props: any, value: string, field: string) =>
  isFieldRequired(props.products, value, field)
    ? Yup.string().required(translate({ ...messages.requiredField }, props))
    : Yup.string();

export default (props: any, values: any) => {
  const { isContratEpargne } = values;
  const requiredEpargnString =
    isContratEpargne &&
    Yup.string().required(translate({ ...messages.requiredField }, props));
  return Yup.object().shape({
    firstName: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    lastName: Yup.string().required(
      translate({ ...messages.requiredField }, props),
    ),
    birthday: Yup.string().test(
      'is-42',
      translate({ ...messages.birthdayInputError }, props),
      (value) => {
        return moment().diff(moment(value), 'years') >= 15;
      },
    ),
    cin: Yup.string().required(translate({ ...messages.requiredField }, props)),
    email: Yup.string()
      .email(translate({ ...messages.emailInputError }, props))
      .required(translate({ ...messages.requiredField }, props)),
    phoneNumber: Yup.string()
      .matches(
        /(\+212|0)([ \-_/]*)(\d[ \-_/]*){9}/,
        translate({ ...messages.validFormPhone }, props),
      )
      .required(translate({ ...messages.requiredField }, props)),
    isAcceptConditions: Yup.boolean().oneOf(
      [true],
      translate({ ...messages.conditionsGeneralError }, props),
    ),
    product: requiredEpargnString,
    numPolice: requiredEpargnString,
    dateEffet: requiredEpargnString,
    ppr: isConditionalFieldRequired(props, values.product, 'ppr'),
    numAdhesion: isConditionalFieldRequired(
      props,
      values.product,
      'numAdhesion',
    ),
    matricule: isConditionalFieldRequired(props, values.product, 'matricule'),
  });
};
